'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdKeyboardControl = function MdKeyboardControl(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 16.6q1.3 0 2.3 1.1t1.1 2.3-1.1 2.3-2.3 1.1-2.3-1.1-1.1-2.3 1.1-2.3 2.3-1.1z m10 0q1.3 0 2.3 1.1t1.1 2.3-1.1 2.3-2.3 1.1-2.3-1.1-1.1-2.3 1.1-2.3 2.3-1.1z m-20 0q1.3 0 2.3 1.1t1.1 2.3-1.1 2.3-2.3 1.1-2.3-1.1-1.1-2.3 1.1-2.3 2.3-1.1z' })
        )
    );
};

exports.default = MdKeyboardControl;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/keyboard-control.js
// module id = 2977
// module chunks = 0